import React, { useState } from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  FabricStyleBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  SKUBatchInventoryBean,
  SkuBatchInventoryPageListPrintRequest,
  DailyInventoryProcessTrackInquiryCriteriaBean,
} from "../ds/ds.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
} from "../modules/BaseModule.js";
import {
  DEFAULT_WAREHOUSE,
} from "../ds/App_Constants.js";
import {
  PopupFabricStyleModule,
  PopupInventoryAdjustmentModule,
  PopupInventoryTransferModule,
  PopupInvoiceModule,
  PopupLogisticReceiptModule,
  PopupPickTicketModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { ReportService } from "../services/ReportService.js";

import {
  AlertToolBox,
  CollapseComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition,
  NumberFormatInputbox,
  DatePickerComponent_adv,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import CustomTable from "../gui_components/CustomTable.js";
class DailyInventoryProcessTrackDetail extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "DailyInventory Process Track Detail Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      isShowAlert: false,
      alertMessage: "",
      success_list: [],
      moduleForPopup: [],
      warehouses: [],

      criteria: new DailyInventoryProcessTrackInquiryCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,

      isShowFabricStyleModule: false,

      isShowColorLookup: false,
      colorLookupHandler: null,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFabricList: true,
      isShowAutoCompleteFabricColorList: true,
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLocationList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",

      isDisableFields: false,
      isCollapsible_open: true,
      is3PL: false,
      fabricStyleData: new FabricStyleBean(),

      totalPages: 0,

      isShowReceivePopupLvl1: false,
      isShowReceivePopupLvl2: false,

      isShowAdjustPopupLvl1: false,
      isShowAdjustPopupLvl2: false,

      isShowShippedPopupLvl1: false,
      isShowShippedPopupLvl2: false,

      receivedQtyList: [],
      receivedInventoryQtyList: [],

      adjustedQtyList: [],
      adjustedInventoryQtyList: [],

      shippedQtyList: [],
      shippedInventoryQtyList: [],
    };
    this.fabricCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };

    let warehouses = attribute_cache.warehouses;
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        this.state.warehouses.push(attr);
      });
    }
    let criteria = this.state.criteria;
    criteria.locationCode = DEFAULT_WAREHOUSE;
    this.setState({
      criteria: criteria,
    });
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,

      this.state.is3PL ? "Item" : "FabricStyle"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.state.warehouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  validate = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";

    if (isEmptyString(data.fabricStyleCode)) {
      let errMsg = "Fabric is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }

    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowPickticketModule: isOpen,
      isShowInventoryAdjustmentModule: isOpen,
      isShowLogisticReceiptModule: isOpen,
      moduleForPopup: [],
    });
  };

  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new DailyInventoryProcessTrackInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.customerName = "";
    criteria.locationCode = DEFAULT_WAREHOUSE;
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      isDisableFields: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new DailyInventoryProcessTrackInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.customerName = "";
    criteria.locationCode = DEFAULT_WAREHOUSE;
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      isShowResetButton: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      isDisableFields: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,

      totalPages: 0,
    });
    this.hideAlertCallBack();
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };

  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowReceivePopupLvl1: isShowPopup,
      isShowAdjustPopupLvl1: isShowPopup,
      isShowShippedPopupLvl1: isShowPopup,
    });
  };

  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };

  /* --------------------------Fabric/Item Onchange -------------------------------- */
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.isShowAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.isShowAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        criteria.fabricStyleColorCode = "";
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readAndSetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    const criteria = this.state.criteria;
    const searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    searchCriteria.logisticCustomerCode = criteria.customerCode;
    const pageList = new RestPageListBean();
    pageList.pageSize = 100;
    const input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.fabricStylePageList) &&
      !isEmptyArray(response.data.fabricStylePageList.fabricStyles)
    ) {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let criteria = this.state.criteria;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
          // }
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readAndSetFabricStyleDetail(fabricStyleCode);
    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteFabricList: showAutoCompleteList });
  };

  /* ----------------------------------Fabric Color ----------------------- */
  onFabricColourCodeChange = (e) => {
    this.state.isShowAutoCompleteFabricColorList = true;
    let fabricStyleColorCode = e.target.value;
    let isShowAutoCompleteFabricColorList =
      this.state.isShowAutoCompleteFabricColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.isShowAutoCompleteFabricColorList = false;
      let isShowAutoCompleteFabricColorList =
        this.state.isShowAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteFabricColorList: isShowAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      isShowAutoCompleteFabricColorList === true &&
      fabricStyleColorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (fabricStyleColorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == fabricStyleColorCode
        )
          skuBean = sku;
      });
    }
    criteria.fabricStyleColorCode = fabricStyleColorCode;
    this.setState({ criteria: criteria });
  };

  /* --------------------------------Warehouse------------------------------ */
  locationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.isShowAutoCompleteLocationList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      let criteria = this.state.criteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteLocationList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.warehouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };

  readLocationBySearchString = (searchString) => {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((sp) => {
        let locationBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteLocationList: showAutoCompleteList });
  };

  /********************************* Customer *********************************/

  onCustomerChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let temp_criteria = this.state.criteria;
      temp_criteria.customerCode = "";
      temp_criteria.customerName = "";
      temp_criteria.fabricStyleCode = "";
      temp_criteria.fabricStyleName = "";
      temp_criteria.fabricStyleColorCode = "";
      let suggestion = [];
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        this.state.is3PL ? "Item" : "FabricStyle",
        temp_criteria.customerCode
      );
      this.setState({
        fabricLookupHandler: fabricLookupHandler,
        isShowColorLookup: false,
      });
      this.setState({
        isShowAutoCompleteCustomerList: showAutoCompleteList,
        criteria: temp_criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
    //this.readCustomer(customerCode);
  };

  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.customerPageList) &&
      !isEmptyArray(response.data.customerPageList.customers)
    ) {
      let customerList = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerList.length > 0 && customerList != null) {
        customerList.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };

  readCustomerResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.customer)) {
      let customerData = response.data.customer;
      let criteria = this.state.criteria;
      criteria.customerCode = customerData.code;
      criteria.customerName = customerData.description;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.fabricStyleColorCode = "";
      this.setState({ criteria: criteria, isShowColorLookup: false });
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        // "Item",
        this.state.is3PL ? "Item" : "FabricStyle",
        criteria.customerCode
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    }
  };

  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerResponse,
      this.errorCallBack
    );
  };
  customerEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomer(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCustomerList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  generatePDF = () => {
    //  this.generateSkuBatchInventoryReport(1);
  };
  generateExcel = () => {
    // this.generateSkuBatchInventoryReport(2);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    this.loadPage(this.state.totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    // let isValid = false;
    // isValid = this.validate(criteria);
    // if (isValid) {
    if (
      SecurityAccessManager.DailyInventoryProcessTrackInquiry_IsAccessible()
    ) {
      ReportService.inquireDailyInventoryProcessTrackDetails(
        criteria,
        this.loadPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
    // }
  };

  loadPageResponse = (response) => {
    this.showErrorMessage(response.data);
    let dailyInventoryList = new Array();
    if (!isEmpty(response.data) && !isEmpty(response.data.resultBean)) {
      if (!isEmptyArray(response.data.resultBean.infos)) {
        dailyInventoryList = response.data.resultBean.infos;
        dailyInventoryList.map((ln) => {
          if (ln.updateEntityType == 20) {
            ln.updateEntityType = "FabricStyleInventoryAdjustment";
          }
        });
        this.setState({
          isInquiryDatasFound: true,
          inquiryDataList: dailyInventoryList,
          isShowResetButton: true,
          isShowClearCriteriaButton: false,
        });
        this.disable();
      }
    }
    this.setState({
      inquiryDataList: dailyInventoryList,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  // generatePDF = () => {
  //   this.generateDailyInventoryTrackReport(1);
  // };
  // generateExcel = () => {
  //   this.generateDailyInventoryTrackReport(2);
  // };
  // generateDailyInventoryTrackReport = (reportType) => {
  //   let criteria = this.state.criteria;
  //   criteria.companyCode = this.companyCode;
  //   let reportBean = new RestReportBean();
  //   reportBean.reportType = reportType;
  //   let pageInput = new RestPageListBean();
  //   // pageInput.pageSize = 20;
  //   // pageInput.currentPage = 1;
  //   let listRequest = new RestPageListBean();
  //   listRequest.searchCriteria = criteria;
  //   listRequest.reportBean = reportBean;
  //   listRequest.pageInput = pageInput;
  //   this.setState({
  //     isShowProgressBarPopup: true,
  //     progressLoadingText: "Generating Report...",
  //   });
  //   if (reportBean.reportType == 1) {
  //     if (
  //       SecurityAccessManager.SkuInventoryTrackInquiryPDFReport_IsAccessible()
  //     ) {
  //       ReportService.generateSkuInventoryTrackPrintOutReport(
  //         listRequest,
  //         this.generateDailyInventoryTrackPageResponse,
  //         this.errorCallBack
  //       );
  //     } else {
  //       this.inValidAccess(2);
  //     }
  //   } else if (reportBean.reportType == 2) {
  //     if (
  //       SecurityAccessManager.SkuBatchInventoryTrackInquiryExcelReport_IsAccessible()
  //     ) {
  //       ReportService.generateSkuInventoryTrackPrintOutReport(
  //         listRequest,
  //         this.generateDailyInventoryTrackPageResponse,
  //         this.errorCallBack
  //       );
  //     } else {
  //       this.inValidAccess(3);
  //     }
  //   }
  // };
  // generateDailyInventoryTrackPageResponse = (response) => {
  //   this.showErrorMessage(response.data);
  //   if (response.data != null && response.data.reportResult != null) {
  //     if (!isEmptyString(response.data.reportResult.reportFileID)) {
  //       let reportFilePath = response.data.reportResult.reportFileID;
  //       window.open(this.report_url + reportFilePath);
  //     }
  //   }
  //   this.setState({
  //     isShowProgressBarPopup: false,
  //     progressLoadingText: "",
  //   });
  // };

  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "createdDate", true,false,true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyleCode",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "FabricStyle Name",
          "fabricStyleName",
          true
        )

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Warehouse", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true, false)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Inventory#", "rollSkuNumber", true, false)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true, false)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("IMEI", "imeiNumber", true, false)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedQty#", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Entity#", "updateEntityCode", true, false)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("EntityType#", "updateEntityType", true, false)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    return columns;
  };
  viewFabricModule = (e, code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowFabricStyleModule: true,
        moduleForPopup: (
          <PopupFabricStyleModule
            fabricStyleCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (rowData.updateEntityType === "FabricStyleInventoryAdjustment") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowInventoryAdjustmentModule: true,
            moduleForPopup: (
              <PopupInventoryAdjustmentModule
                code={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.updateEntityType === "Invoice") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowInvoiceModule: true,
            moduleForPopup: (
              <PopupInvoiceModule
                invoiceCode={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.updateEntityType === "PickTicket") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowPickticketModule: true,
            moduleForPopup: (
              <PopupPickTicketModule
                pickTicketCode={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.updateEntityType === "LogisticOrderReceipt") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowLogisticReceiptModule: true,
            moduleForPopup: (
              <PopupLogisticReceiptModule
                code={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      }
      // else if (rowData.updateProcess === "InventoryTransferLocation") {
      //   if (code !== "" && code !== undefined) {
      //     this.setState({
      //       isShowInventoryTransferModule: true,
      //       moduleForPopup: (
      //         <PopupInventoryTransferModule
      //           code={code}
      //           onModuleExit={this.onPopupModalExit}
      //         />
      //       ),
      //     });
      //   }
      // }
    }
  };
  render() {
    const inquiryDataList = this.state.inquiryDataList;

    let criteria = this.state.criteria;
    let pageList = this.state.pageList;
    let totalPages = 0;
    totalPages = this.state.totalPages;
    let pageSize = pageList.pageSize;

    let currentPage = pageList.currentPage;

    let is3PL = this.state.is3PL;

    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          {...this.state}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          showHideSecondHeader={this.showHideSecondHeader}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricCodeRef={this.fabricCodeRef}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          locationCodeOnChange={this.locationCodeOnChange}
          locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
          displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
          onCustomerChange={this.onCustomerChange}
          customerEnterKeyEventHandler={this.customerEnterKeyEventHandler}
          displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
        />
        {/* {this.state.isInquiryDatasFound ? (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        ) : null} */}
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              label={"Daily Inventory Process Track Report"}
            />
          </div>
        )}

        {/**************************  Module Popup *******************************/}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInventoryAdjustmentModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPickticketModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowLogisticReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInventoryTransferModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);

  let criteria = props.criteria;
  let fabricLookupHandler = props.fabricLookupHandler;
  let warehouseLookupHandler = props.warehouseLookupHandler;

  const fabricCodeRef = props.fabricCodeRef;
  let isDisableFields = props.isDisableFields;
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const fabricEnterKeyEventHandler = (e) => props.fabricEnterKeyEventHandler(e);
  const displayAutoCompleteFabricList = (e) =>
    props.displayAutoCompleteFabricList(e);

  const onFabricColourCodeChange = (e) => props.onFabricColourCodeChange(e);

  const fabricColourEnterKeyEventHandler = (e) =>
    props.fabricColourEnterKeyEventHandler(e);

  const displayAutoCompleteFabricColorList = () =>
    props.displayAutoCompleteFabricColorList();
  const locationCodeOnChange = (e) => props.locationCodeOnChange(e);

  const locationEnterKeyEventHandler = (e) =>
    props.locationEnterKeyEventHandler(e);

  const displayAutoCompleteLocationList = () =>
    props.displayAutoCompleteLocationList();

  return (
    <div>
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            <FormLabel>From Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="fromDate"
              onChange={onChange}
              value={criteria.fromDate}
             disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>To Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="toDate"
              onChange={onChange}
              value={criteria.toDate}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={props.onCustomerChange}
              value={criteria.customerCode}
              name="customerCode"
              placeholder="customer"
              lookupRequired={true}
              lookupHandler={props.customerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={props.customerEnterKeyEventHandler}
              autoCompleteListData={props.customerPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={props.displayAutoCompleteCustomerList}
              showAutoCompleteList={props.isShowAutoCompleteCustomerList}
             // disabled={false}
             disabled={isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              value={criteria.customerName}
              name="customerName"
              disabled={true}
            />
          </Col>
          <Col>
            <CollapseComponent
              isOpen={props.isCollapsible_open}
              onClick={(e) => props.showHideSecondHeader(e)}
            />
          </Col>
        </Row>

        {props.isCollapsible_open && (
          <Row>
            <Col sm="1">
              <FormLabel>Item</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={fabricCodeRef}
                name="fabricStyleCode"
                onChange={fabricCodeOnChange}
                value={criteria.fabricStyleCode}
                placeholder="item"
                lookupRequired={true}
                lookupHandler={props.fabricLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={fabricEnterKeyEventHandler}
                autoCompleteListData={props.fabricPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayAutoCompleteFabricList}
                showAutoCompleteList={props.isShowAutoCompleteFabricList}
                 disabled={isDisableFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="3">
              <InputTextbox
                name="fabricStyleName"
                onChange={onChange}
                value={criteria.fabricStyleName}
                disabled={true}
              />
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>Color</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={onFabricColourCodeChange}
                //   onChange={onFabricColourCodeChange}
                name="fabricStyleColorCode"
                placeholder="color"
                value={criteria.fabricStyleColorCode}
                lookupRequired={props.isShowColorLookup}
                lookupHandler={props.colorLookupHandler}
                enterKeyEventHandler={fabricColourEnterKeyEventHandler}
                autoCompleteListData={
                  props.fabricColourPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayAutoCompleteFabricColorList}
                showAutoCompleteList={props.isShowAutoCompleteFabricColorList}
                disabled={!props.isShowColorLookup}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Location</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={locationCodeOnChange}
                name="locationCode"
                placeholder="location"
                value={criteria.locationCode}
                lookupRequired={true}
                lookupHandler={warehouseLookupHandler}
                enterKeyEventHandler={locationEnterKeyEventHandler}
                autoCompleteListData={props.locationPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayAutoCompleteLocationList}
                showAutoCompleteList={props.isShowAutoCompleteLocationList}
                disabled={isDisableFields}
                isMandatory={true}
              />
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
}
function DailyInventoryProcessTrackDetailInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <DailyInventoryProcessTrackDetail {...props} name="" /> <br />
    </div>
  );
}

export default DailyInventoryProcessTrackDetailInquiry;
